document.addEventListener('DOMContentLoaded', function () {


    document.querySelectorAll('.variant-quantity .quantity-selector--minus').forEach(function(element) {

        element.off("click keydown");


        let theInput = element.closest('quantity-selector').querySelector('.quantity-selector--input');

        element.on("click keydown", t => {
            if (theInput.value > 0){
                theInput.value = theInput.value - 1;
            }
        })
    })

});

window.newCustomerAccountsEnabled = true;